import { selectSubcategory } from 'owa-options-orchestration';
import { getStore } from 'owa-options-store';
import { observer } from 'mobx-react';
import { BaseButton } from 'office-ui-fabric-react/lib/Button';
import { OptionSubCategory } from 'owa-options-core';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { AnimationClassNames } from '@uifabric/styling';
import { FocusZone, FocusZoneDirection } from 'office-ui-fabric-react/lib/FocusZone';

const styles = require('./OptionsFull.scss');
const className = require('classnames/bind').bind(styles);

interface OptionEntryProps {
    subcategory: OptionSubCategory;
}

const SubCategoryEntry = observer((props: OptionEntryProps) => {
    let buttonStyles = {
        root: className(styles.option, {
            selectedOption: getStore().currentSubCategoryKey === props.subcategory.key,
        }),
        flexContainer: styles.optionFlexContainer,
        label: styles.optionLabel,
    };

    return (
        <BaseButton
            styles={buttonStyles}
            key={props.subcategory.key}
            onClick={() => selectSubcategory(props.subcategory)}
            text={strings[props.subcategory.titleStringKey] as string}
            role="tab"
        />
    );
});

export interface OptionsColumnProps {
    subcategories: OptionSubCategory[];
}

@observer
export default class SubCategoriesColumn extends React.Component<OptionsColumnProps, {}> {
    render() {
        return (
            <div className={styles.optionsColumn} role="tablist">
                <FocusZone
                    direction={FocusZoneDirection.vertical}
                    key={getStore().currentCategoryKey}
                    className={AnimationClassNames.slideLeftIn20}>
                    {this.props.subcategories.map(subcategory => (
                        <SubCategoryEntry subcategory={subcategory} key={subcategory.key} />
                    ))}
                </FocusZone>
            </div>
        );
    }
}
